import axios from 'axios';
import REACT_APP_BACK_URL from '../../constants/constants';

export const checkInviteToken = async ({ token }) => axios.get(`${REACT_APP_BACK_URL}/invite/${token}`);

export const acceptInvitation = async () => axios.post(`${REACT_APP_BACK_URL}/invitations/accept`);

export const declineInvitation = async () => axios.post(`${REACT_APP_BACK_URL}/invitations/decline`);
